import { render, staticRenderFns } from "./list1.vue?vue&type=template&id=378377ac&scoped=true&"
import script from "./list1.vue?vue&type=script&lang=js&"
export * from "./list1.vue?vue&type=script&lang=js&"
import style0 from "./list1.vue?vue&type=style&index=0&id=378377ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378377ac",
  null
  
)

export default component.exports